var moduleMap = {
	"./App": () => {
		return Promise.all([__webpack_require__.e(7865), __webpack_require__.e(8270), __webpack_require__.e(4566), __webpack_require__.e(2141), __webpack_require__.e(6086), __webpack_require__.e(3953), __webpack_require__.e(903), __webpack_require__.e(3261), __webpack_require__.e(9205), __webpack_require__.e(3081), __webpack_require__.e(7635), __webpack_require__.e(869), __webpack_require__.e(3667), __webpack_require__.e(6233), __webpack_require__.e(7476), __webpack_require__.e(8146), __webpack_require__.e(4201), __webpack_require__.e(5916), __webpack_require__.e(5171), __webpack_require__.e(9317), __webpack_require__.e(3091), __webpack_require__.e(3586), __webpack_require__.e(1512), __webpack_require__.e(2921), __webpack_require__.e(9075), __webpack_require__.e(5441), __webpack_require__.e(7043), __webpack_require__.e(1306), __webpack_require__.e(3279), __webpack_require__.e(9750), __webpack_require__.e(3387), __webpack_require__.e(318), __webpack_require__.e(7371), __webpack_require__.e(633), __webpack_require__.e(4432)]).then(() => (() => ((__webpack_require__(17391)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});